const translations = {
  "en": {
    "Brokerages, retirement, robo-advisors": "Brokerages, retirement, robo-advisors",
    "Checking, savings, credit cards": "Checking, savings, credit cards",
    "Connect banking account": "Connect banking account",
    "Connect investment account": "Connect investment account"
  },
  "zh-tw": {
    "Brokerages, retirement, robo-advisors": "券商、退休帳戶、智能投顧",
    "Checking, savings, credit cards": "支票帳戶、儲蓄帳戶、信用卡",
    "Connect banking account": "綁定銀行帳戶",
    "Connect investment account": "連接投資帳戶"
  }
};

export default translations;
